import { NavLink as Link } from "react-router-dom";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import PartnerLogo from "../../images/Partner-Managment.png";
import { connect } from "react-redux";
import "./styles.css";
import AccessLogo from "../../images/Access-Management.png";
import Human from "../../images/human1.png";
import Dashboardlogo from "../../images/Dashboardlogo.png";
import padlock from "../../images/lock.png";
import { HomeOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";


const LeadManagementDashboardList = (props) => {
  const id = useSelector((state) => state?.auth?.checkLogin?.partnerFirmId);
  const isPrimary = useSelector(
    (state) => state?.dashboardReducer?.dashboardDetails?.data?.dto?.isPrimary
  );
   const isPrimaryuser = useSelector(
    (state) => state?.auth?.userData?.isPrimary
  );
  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  const FirmDetailStatus =
    partnerSidebarDtoList?.find(
      (item) =>
        item.page === "FirmDetails" ||
        item.page === "BranchDetails" ||
        item.page === "TeamDetails" ||
        item.page === "Documents"
    )?.status === "COMPLETE"
      ? true
      : false;

  const roleType = props.userDetail?.loggedInRoleType;
  const userMangementShowSection =
    roleType === "PARTNER" || (roleType === "PLMU" && isPrimary);

  return (
    <div>
      <div className="log-avs">
        <img src={Logo} alt="" />
      </div>
      <div className="list-contnt">
        <ul className="list">
          {(roleType == "PARTNER" ||
            roleType == "POU" ||
            roleType == "PLMU") && (
            <li className="">
              <Link
                className="ListItem"
                to="/leadManagementDashboard/Dashboard"
              >
                <HomeOutlined
                  className="sidebarIcon mx-3"
                  style={{ fontSize: "24px", color: "white" }}
                />
                <span className="list-Text">Home</span>
              </Link>
            </li>
            
          )}
          {(roleType == "PARTNER" ||
            roleType == "POU" ||
            roleType == "PLMU") && (
            <li className="">
              <Link className="ListItem " to={"AdvancedDashboard"}>
                <img
                  src={Dashboardlogo}
                  alt="Advanced Dashboard"
                  className="sidebarIcon"
                />
                <span className="list-Text">Advanced DashBoard</span>
              </Link>
            </li>
          )}

          {(roleType == "PARTNER" || roleType == "POU") && (
            <li className="">
              <Link
                className="ListItem "
                to={
                  props.partnerFirmDetails?.partnerFirmStatus ===
                    "FOR_VERIFICATION" ||
                    props.partnerFirmDetails?.partnerFirmStatus ===
                    "ESIGN_PENDING" ||
                  props.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
                    ? `/leadManagementDashboard/viewPartner`
                    : `/PartnerDashBoard/EngagementDetails`
                }
                state={{ partnerFirmId: +id }}
              >
                <img src={AccessLogo} alt="" className="sidebarIcon" />
                <span className="list-Text"> Firm Details</span>
              </Link>
            </li>
          )}
          
          {(roleType == "PARTNER" || roleType == "PLMU") &&
            (props?.partnerFirmDetails?.partnerFirmStatus === "NEW_PARTNER" &&
              FirmDetailStatus === false ? (
              <>
                <div className="btn-seclast new">
                  <div className="lock-sidebar">
                    <img src={PartnerLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Lead Management</span>
                  </div>
                  <div className="lock-sidebar-img new">
                    <img src={padlock} alt="" />
                  </div>
                </div>
              </>
            ) : (
              <li className="">
                <Link
                  className="ListItem"
                  to="/leadManagementDashboard/leadManagement"
                >
                  <img src={PartnerLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text"> Lead Management</span>
                </Link>
              </li>
            ))}
            
            
            
            { ( roleType === "PARTNER" || (roleType === "PLMU" && isPrimaryuser)) &&
              <li className="">
                <Link
                  className="ListItem"
                  to="/leadManagementDashboard/payoutDashboard"
                >
                  <img src={PartnerLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text"> Partner Payout Report</span>
                </Link>
              </li>
              }

          {userMangementShowSection && (
            <>
            <li className="">
              <Link
                className="ListItem"
                to="/leadManagementDashboard/userManagement"
              >
                <img src={Human} alt="" className="sidebarIcon" />
                <span className="list-Text">User Management</span>
              </Link>
            </li>
              </>
          )}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    checkLogin: state?.auth?.checkLogin,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    partnerFirmDetails:
      state?.auth?.partnerFirmDetails ||
      state?.auth?.checkLogin?.partnerFirmDetails,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    userDetail: state.auth?.userData,
    is_Primary: state?.loginCredentials?.data?.dto?.isPrimary,
  };
};

export default connect(mapStateToProps)(LeadManagementDashboardList);
